import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { isNotNil } from 'utils/ramdaUtils';

import { createArrangement, getArrangement } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const useGetArrangement = (rowId) => {
  const { t } = useTranslation('common');

  return useQuery({
    enabled: isNotNil(rowId),
    queryKey: ['travel', 'details', rowId],
    queryFn: async () =>
      await getArrangement(rowId).then((response) => response.data),
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};

export const useSaveWithMutation = (onClose) => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(createArrangement, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['travel']
      });
      onClose();
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar(
        t('adminPortal.errorDuringSave', {
          name: t('tableTabs.ARRANGEMENTS')
        })
      );
    }
  });

  return { mutate, isLoading };
};
